export default __webpack_public_path__ + "media/images/images/carousel/13-ba90213310d62cc188f1cc2b4e9c9e7a.jpg";